<template>
    <v-container fluid>
        <v-expansion-panels
            v-if="this.user != null && this.user.role == 'Admin'"
        >
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <h4>REPORTS</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col col="8">
                            <v-btn
                                color="blue-grey"
                                class="ma-2 white--text"
                                :to="{ name: 'report-list' }"
                            >
                                Lista Report<v-icon right dark>
                                    mdi-playlist-edit
                                </v-icon>
                            </v-btn>
                            <v-btn
                                color="deep-orange"
                                class="ma-2 white--text"
                                @click="reportUnselect()"
                            >
                                Rimuovi selezione<v-icon right dark>
                                    mdi-list-status
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col col="4" class="text-right">
                            <v-btn
                                depressed
                                color="primary"
                                :to="{
                                    name: 'report1',
                                    params: { report: 'report1' },
                                }"
                            >
                                Report 1
                            </v-btn>
                            <v-btn
                                depressed
                                color="primary"
                                :to="{
                                    name: 'report1',
                                    params: { report: 'report2' },
                                }"
                            >
                                Report 2
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <Filters
            ref="filters-component"
            @sendSearch="sendFiltersCallback"
            :numArticoli="numArticoli"
        ></Filters>
        <v-row v-if="searching">
            <v-col class="text-center">
                <v-progress-circular indeterminate></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-if="!searching">
            <v-col
                md="2"
                sm="6"
                xs="12"
                v-for="(product, index) in listItems"
                :key="index"
            >
                <v-card max-height="250" height="250">
                    <ProductImage
                        :productId="product.ar_codart"
                        :height="120"
                        :linkTo="{
                            name: 'product',
                            query: { id: product.ar_codart },
                        }"
                    >
                    </ProductImage>
                    <v-card-title class="body-2">
                        <v-row no-gutters class="d-flex align-center">
                            <v-col class="col-sm-8">
                                <router-link
                                    target="_blank"
                                    :to="{
                                        name: 'product',
                                        query: { id: product.ar_codart },
                                    }"
                                >
                                    {{ product.ar_codart }}
                                </router-link>
                            </v-col>
                            <v-col class="col-sm-4">
                                <v-simple-checkbox
                                    v-model="product.flag_report"
                                    :value="true"
                                    @input="checkProduct(product)"
                                ></v-simple-checkbox>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-subtitle>
                        <div class="caption">
                            {{ product.ar_descr }} <br />STOCK:
                            <b>{{ product.xx_dissede }}</b>
                            <br />COD FORN: <b>{{ product.xx_codarfo }}</b>
                        </div>
                    </v-card-subtitle>
                </v-card>
            </v-col>
            <infinite-loading @infinite="loadMore">
                <div slot="no-more">Non sono presenti altri articoli</div>
                <div slot="no-results">Non sono stati trovati articoli</div>
            </infinite-loading>
        </v-row>
    </v-container>
</template>
<style scoped lang="scss">
.v-expansion-panel-header {
    padding: 16px;
}

.v-expansion-panel-content::v-deep > .v-expansion-panel-content__wrap {
    padding: 0 16px 16px !important;
}
</style>
<script>
import requests from "../requests";
import Filters from "./Filters.vue";
import ProductImage from "./ProductImage.vue";
const NUM_LOAD_ITEMS = 24;

export default {
    name: "product-list",
    components: { Filters, ProductImage },
    props: {
        filters: null,
    },
    data: () => {
        return {
            items: [],
            listItems: [],
            numArticoli: 0,
            searching: false,
            tmpFilters: null,
            cont: 0,
            user: null,
        };
    },
    mounted() {
        console.log("Product List Mounted.");
        //this.sendSearchProduct({ inStock: true });
        this.user = window.currentUser;
        this.$refs["filters-component"].sendSearch();
    },

    methods: {
        sendFiltersCallback(filters) {
            this.tmpFilters = Object.assign({}, filters);

            delete filters.selectedFamily;
            delete filters.selectedSubFamily;
            delete filters.codProdotto;

            this.sendSearchProduct(filters);
        },

        sendSearchProduct(filters) {
            this.searching = true;
            requests.searchProduct(filters).then((res) => {
                let tmpFilters = res.data;
                if (!_.isNull(this.tmpFilters)) {
                    if (!_.isNull(this.tmpFilters.selectedFamily)) {
                        tmpFilters = _.filter(res.data, {
                            acl_descla1: this.tmpFilters.selectedFamily,
                        });
                    }

                    if (!_.isNull(this.tmpFilters.selectedSubFamily)) {
                        tmpFilters = _.filter(tmpFilters, {
                            acl_descla2: this.tmpFilters.selectedSubFamily,
                        });
                    }

                    if (!_.isNull(this.tmpFilters.codProdotto)) {
                        tmpFilters = _.filter(tmpFilters, (o) => {
                            return (
                                o.ar_codart.indexOf(
                                    this.tmpFilters.codProdotto
                                ) > -1
                            );
                        });
                    }

                    if (!_.isNull(this.tmpFilters.codArtForn)) {
                        tmpFilters = _.filter(tmpFilters, {
                            xx_codarfo: this.tmpFilters.codArtForn,
                        });
                    }

                    if (!_.isNull(this.tmpFilters.dataCarico)) {
                        tmpFilters = _.filter(tmpFilters, {
                            xx_jac_primadatacm: this.tmpFilters.dataCarico,
                        });
                    }

                    if (this.tmpFilters.inStock) {
                        tmpFilters = _.filter(tmpFilters, (o) => {
                            return o.xx_dissede > 0;
                        });
                    }
                }

                this.items = tmpFilters;
                this.numArticoli = tmpFilters.length;
                this.listItems = [];

                this.cont += NUM_LOAD_ITEMS;
                this.listItems.push(
                    ..._.slice(this.items, this.listItems.length, this.cont)
                );
                this.searching = false;
            });
        },

        checkProduct(item) {
            requests.changeProductFlag(item.id, item.flag_report);
        },

        loadMore($state) {
            let complete = false;
            this.cont += NUM_LOAD_ITEMS;
            if (this.listItems.length + this.cont >= this.items.length) {
                this.cont -= NUM_LOAD_ITEMS;
                this.cont += this.items.length - this.listItems.length;
                complete = true;
            }
            this.listItems.push(
                ..._.slice(this.items, this.listItems.length, this.cont)
            );
            if (complete) $state.complete();
            else $state.loaded();
        },

        reportUnselect() {
            requests.reportUnselect().then(() => {
                this.$refs["filters-component"].sendSearch();
            });
        },
    },
};
</script>
